import { configPublic } from '@src/config.public'
import { ServerActions } from '@src/services/server-actions.service'
import { COOKIES } from '@src/utils/constants.util'
import { log } from '@src/utils/log.util'

const getRecaptchaToken = async (action: string) => {
  return await new Promise(async (resolve) => {
    await ServerActions.serial.removeCookie(COOKIES.recaptchaToken)

    const grecaptcha = typeof window !== 'undefined' ? (window as any)?.grecaptcha : undefined

    if (!grecaptcha) {
      log.error('The Recaptcha SDK (window.grecaptcha) was not found.')
      resolve(undefined)
    }

    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(configPublic.googleRecaptcha.siteKey, { action })
        log.debug('[Recaptcha] token received', { token })
        await ServerActions.serial.setCookie(COOKIES.recaptchaToken, token)
        resolve(token)
      } catch (error: any) {
        log.error(`[Recaptcha] Error getting token - ${error?.message}`, error)
        resolve(undefined)
      }
    })
  })
}

export const useRecaptchaV3 = () => {
  return {
    getRecaptchaToken,
  }
}
